import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import PopupV2 from '../../../../Popup/PopupV2';
import styles from '../../collegeProspectTab.scss';

const TESTID_PREFIX = 'modal.alert-college-info';

const actionsRowStyle = {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
};

const closeButtonStyle = {
    background: '#000',
    color: '#fff',
    border: 'none',
    borderRadius: '999px',
    padding: '10px 36px',
    fontSize: '13px',
    fontWeight: 700,
    letterSpacing: '1px',
    cursor: 'pointer',
};

const AlertCollegeInfoModal = ({ onClose }) => {
    const modalRef = useRef(null);

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };
        document.addEventListener('keydown', handleEsc);
        return () => {
            document.removeEventListener('keydown', handleEsc);
        };
    }, [onClose]);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [onClose]);

    return (
        <PopupV2
            onCloseClick={onClose}
            config={{
                size: 'fullScreenOnMobile',
                customWidth: 400,
                customHeader: () => null,
            }}
        >
            <div
                ref={modalRef}
                className={styles.alertInfoModal}
                data-testid={`${TESTID_PREFIX}.container`}
            >
                <div
                    className={styles.modalTitle}
                    data-testid={`${TESTID_PREFIX}.title`}
                >
                    About Alert College
                </div>
                <div
                    className={styles.modalContent}
                    data-testid={`${TESTID_PREFIX}.body`}
                >
                    <p>
                        Turning on <strong>Alert College</strong> surfaces you to that program&apos;s coaches in their <em>Recruits That Like Me</em> list.
                    </p>
                    <p>
                        Enabling it triggers an email to the program&apos;s coaches, debounced to no more than one notification per 24 hours per college.
                    </p>
                    <p>
                        You can turn it off at any time.
                    </p>
                </div>
                <div className={styles.modalActions} style={actionsRowStyle}>
                    <button
                        type="button"
                        className={styles.closeButton}
                        style={closeButtonStyle}
                        onClick={onClose}
                        data-testid={`${TESTID_PREFIX}.close-btn`}
                    >
                        CLOSE
                    </button>
                </div>
            </div>
        </PopupV2>
    );
};

AlertCollegeInfoModal.propTypes = {
    onClose: PropTypes.func.isRequired,
};

export default AlertCollegeInfoModal;
